/**
 * How far a label has to travel, and how long it should take.
 *
 * Separated from the measuring so the rules can be tested: `scrollWidth` is
 * always zero without a layout engine, and a test that faked one would be a
 * double wider than the real thing.
 */

/** Below this, an overflow is a rounding artefact rather than clipped text. */
const NOISE_PX = 1;

/** Reading speed. Slow enough to read, fast enough not to wait. */
const PX_PER_SECOND = 50;

/** A tiny overflow still gets a whole gesture rather than a twitch. */
const MIN_SECONDS = 0.6;

export function scrollDistance(scrollWidth, clientWidth) {
  const over = scrollWidth - clientWidth;
  return over > NOISE_PX ? over : 0;
}

export function scrollSeconds(distance) {
  if (distance <= 0) return 0;
  return Math.max(MIN_SECONDS, distance / PX_PER_SECOND);
}
